<template>
    <FormSection
        :full-height="false"
        title="Reassign Task"
        :application-id="visitDetails.Application"
        :show-product-pill="true"
        :show-background="true"
        :use-gray-theme="true"
    >
        <template #content>
            <section class="p-5 d-flex flex-column text-center text-primary" v-if="isLoading">
                <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                <span class="mt-1 big-text">
                    <b>Loading...</b>
                </span>
            </section>
            <section v-else id="product-reassign">
                <div class="dialog container d-flex flex-column m-0 py-2 reassign-dialog">
                    <div class="d-flex align-items-start gap-1 justify-content-between mt-2">
                        <div class="col-6 pb-1 mb-2"><strong>Task</strong></div>
                        <div class="col-6 pb-1 mb-2">{{ visitDetails.TaskName }}</div>
                    </div>
                    <div class="d-flex align-items-start gap-1 justify-content-between">
                        <div class="col-6 pb-1 mb-2"><strong>Patient</strong></div>
                        <div class="col-6 pb-1 mb-2">{{ visitDetails.FirstName }} {{ visitDetails.LastName }}</div>
                    </div>
                    <div class="d-flex align-items-start gap-1 justify-content-between">
                        <div class="col-6 pb-1 mb-2"><strong>Scheduled Date/Time</strong></div>
                        <div v-if="visitDetails.StartDateTime" class="col-6 pb-1 mb-2">
                            {{ formatDateFromDate(visitDetails.StartDateTime) }}
                            {{ formatTime(visitDetails.StartDateTime) + " - " + formatTime(visitDetails.EndDateTime) }}
                        </div>
                        <div v-else class="col-6 pb-1 mb-2">
                            {{ formatDateFromDate(visitDetails.StartDate) }}
                            {{ visitDetails.StartTime ? formatTime(visitDetails.StartTime) : "" }}
                            {{ visitDetails.EndTime ? " - " + formatTime(visitDetails.EndTime) : "" }}
                        </div>
                    </div>
                    <div class="d-flex align-items-start gap-1 justify-content-between">
                        <div class="col-6 pb-1 mb-2"><strong>Existing User/Employee</strong></div>
                        <div class="col-6 pb-1 mb-2" v-if="!visitDetails.UserFirstName && !visitDetails.UserLastName">
                            Unassigned
                        </div>
                        <div v-else class="col-6 pb-1 mb-2">
                            {{ visitDetails.UserFirstName }} {{ visitDetails.UserLastName }}
                        </div>
                    </div>
                    <div class="d-flex align-items-start gap-1 justify-content-between">
                        <div class="col-6 pb-1 mb-2">
                            <strong>New User/Employee</strong> <span class="text-danger">*</span>
                        </div>
                        <div class="col-6 pb-1 mb-2" v-if="preSelectedEmpId">
                            {{ visitDetails.Employee?.firstName }} {{ visitDetails.Employee?.lastName }}
                        </div>
                        <div class="col-7 pb-1 mb-2 reassign-search-box" v-else>
                            <TypeaheadInput
                                :getData="employeeListFilter"
                                :value="scheduleEmployee"
                                v-on:valueChanged="changescheduleEmployee"
                                placeholder="Type to Select User"
                                :show-all-by-default="true"
                                :open-on-focus="true"
                                dropdown-menu-class="custom-menu dropdown"
                                v-on:blurredInput="v$.scheduleEmployee?.$touch"
                                :class="`${!v$.scheduleEmployee?.$error ? '' : 'field-invalid'}`"
                            />
                            <span v-if="v$.scheduleEmployee?.$error" class="field-invalid">Employee is Required.</span>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center mb-3 mt-2" v-if="!isLoading">
                    <span v-if="isSaving">
                        <button class="btn btn-primary">
                            <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                        </button>
                    </span>
                    <span v-else>
                        <button type="button" class="btn btn-md btn-outline-secondary" @click="cancel()">Cancel</button>
                        <button class="btn btn-primary ms-2" @click="reassignVisit()">Reassign</button>
                        <SaveNotifyUser
                            :agency-id="visitDetails?.AgencyId"
                            :button-name="'Reassign and Notify Employee'"
                            v-on:handleSaveVisit="reassignVisit(true)"
                        />
                    </span>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<style src="./ProductReassign.scss"></style>
<script lang="ts" src="./ProductReassign.ts"></script>
